// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cYz-W","questions":"styles_questions__gwmqO","footer":"styles_footer__dmBVL"};